// スタイルシートを読み込む
import "./sass/style.scss";
import jQuery from "jquery";
// swiper関連
// import Swiper from "swiper/bundle";

// IntersectionObserverの読み込み
import { moveClass } from "./js/IntersectionObserver";

//スマホボタン、メニューの処理のファイルを読み込む
import { spMenuMove } from "./js/spMenuMove";

//タブに関するファイル
// import { tab } from './js/tab';

//アコーディオンに関するファイルの読み込み
import { accordionMove } from './js/accordion';


import { swipe } from './js/swipe';

//サイドメニューの折りたたみ
import { folding } from './js/folding';

//スマートハウスって：画像切り替え
import { imageChange } from './js/image-change';

//スマートハウス、戻るボタンが押された時のスタイルの初期化
import { styleUndo } from './js/styleUndo';

import { contact } from './js/contact';



//IntersectionObserverの実行
moveClass();


//スマホメニュー周りの処理
spMenuMove();

//タブのclass付け替え
// tab();

//アコーディオンに関する処理
accordionMove();

// URLの取得
let url = location.href;
let path = window.location.pathname

console.log(path);

// トップページのみswiper実行
if (path === "/") {
	swipe();
}

//折りたたみメニュー
folding();

//スマートハウスって画像切り替え
imageChange();

styleUndo();

contact();



